import { TDefineDocumentUploadListStore } from '@/stores/define-document-upload';
import { randomId } from '@/utils';

import { clone } from 'ramda';

import {
	FileStatusEnum,
	StatusDocumentUpload,
} from './define-document-upload.config';
import { LocalFile } from './define-document-upload.type';

export const formatLocalFile = (
	currentListFile: LocalFile[],
	newListFile: File[]
) => {
	let renameNewListFile: LocalFile[] = [];

	Array.from(newListFile).forEach((file, index) => {
		let fileName = file.name;
		let fileIndex = 1;
		while (
			currentListFile.some(
				(existingFile) => existingFile?.file?.name === fileName
			)
		) {
			const baseName = file.name.split('.').slice(0, -1).join('.');
			const extension = file.name.split('.').pop();
			fileName = `${baseName}(${fileIndex}).${extension}`;
			fileIndex++;
		}
		const renamedFile = new File([file], fileName, { type: file.type });
		renameNewListFile = [
			...renameNewListFile,
			{
				...currentListFile[index],
				id: randomId() + index,
				file: renamedFile,
				progress: 0,
				status: FileStatusEnum.WAITING,
			},
		];
	});

	return renameNewListFile;
};

export const mergeArrayDocumentUpload = (
	arrayA: TDefineDocumentUploadListStore,
	arrayB: TDefineDocumentUploadListStore
) => {
	let result = clone(arrayA);

	const docTypes = Array.from(
		new Set([...arrayA, ...arrayB].map((item) => item.documentType))
	);

	docTypes.forEach((docType) => {
		const lastIndexInA = result
			.map((item) => item.documentType)
			.lastIndexOf(docType);

		const itemsFromB = arrayB.filter((item) => item.documentType === docType);

		result = result.map((itemA) => {
			const matchingItem = itemsFromB.find(
				(itemB) =>
					itemB.id === itemA.id && itemB.documentType === itemA.documentType
			);
			return matchingItem ? matchingItem : itemA;
		});

		const itemsBRemain = itemsFromB.filter(
			(itemB) =>
				!result.some(
					(itemA) =>
						itemA.id === itemB.id && itemA.documentType === itemB.documentType
				)
		);

		if (itemsBRemain.length > 0 && lastIndexInA !== -1) {
			result.splice(lastIndexInA + 1, 0, ...itemsBRemain);
		}
	});

	return result;
};

export const formatReqUpdateDocumentList = (
	documents: TDefineDocumentUploadListStore
) => {
	return documents
		.filter(
			(item) =>
				item?.fileList?.id &&
				!(item.statusDocumentUpload === StatusDocumentUpload.ADD && item.hidden)
		)
		.map((item) => ({
			id: item?.fileList?.id,
			documentType: item.documentType,
			reqReferList: item.mappingList
				?.filter((mapping) => mapping.refTableId)
				?.map((mapping) => ({
					refTableName: mapping.refTableName,
					refTableId: mapping.refTableId,
					id:
						mapping?.status !== StatusDocumentUpload.ADD
							? mapping?.id
							: undefined,
				})),
		}));
};
